import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { checkRole } from "@/api/data";
import { banRoleChat } from "@/api/role";
import serverList from "../../../components/serverList/serverOptions.vue";
export default {
  components: {
    serverList: serverList
  },
  data: function data() {
    return {
      form: {},
      //玩家ID输入的字符串,后面转数组
      playerIDString: ""
    };
  },
  watch: {
    playerIDString: {
      handler: function handler(newVal) {
        this.form.role_list = newVal.split(",");
      }
    }
  },
  methods: {
    //多人禁言
    preserBtn: function preserBtn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res1, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return checkRole({
                roleList: _this.form.role_list,
                serverId: _this.form.server_id
              });
            case 2:
              res1 = _context.sent;
              if (!(res1.code === 0)) {
                _context.next = 10;
                break;
              }
              _context.next = 6;
              return banRoleChat(_this.form);
            case 6:
              res = _context.sent;
              if (res.code == 0) {
                _this.centerDialogVisible = false;
                _this.$message({
                  type: "success",
                  message: "禁言多人成功"
                });
                _this.backPerson();
              } else {
                _this.$message({
                  type: "error",
                  message: "禁言多人失败"
                });
                _this.backPerson();
              }
              _context.next = 12;
              break;
            case 10:
              _this.$message({
                type: "error",
                message: "禁言中的ID不存在"
              });
              _this.playerIDString = "";
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    backPerson: function backPerson() {
      var data = {
        isBack: false
      };
      this.$emit("backPerson", data);
    }
  }
};